<template><div ref="chart" class="score-box"></div></template>

<script>
const scoreLabels = ['×', '<3.5', '<3.6', '<3.7', '<3.8', '<3.9', '<4.0', '<4.1', '<4.2', '<4.3', '<4.4', '<4.5', '<4.6', '<4.7', '<4.8', '<4.9', '<5.0', '=5.0']

export default {
  name: 'ScoreCharts',
  props: { data: { type: Array, default: () => [] } },
  watch: { data: { handler: 'updateChart', deep: true } },
  mounted() {
    this.chart = this.$echarts.init(this.$refs.chart)
    this.chart.setOption({
      color: ['#409eff'],
      tooltip: { trigger: 'axis', axisPointer: { type: 'line' } },
      grid: { left: 10, right: 18, top: 22, bottom: 14, containLabel: true },
      xAxis: { type: 'category', boundaryGap: false, data: scoreLabels, axisLine: { lineStyle: { color: '#c0c4cc' } }, axisTick: { show: false }, axisLabel: { color: '#909399', fontSize: 10, interval: 1 } },
      yAxis: { type: 'value', axisLabel: { color: '#909399', fontSize: 10 }, splitLine: { lineStyle: { color: 'rgba(220, 223, 230, .65)' } } },
      series: [{ name: '作品数', type: 'line', smooth: .3, symbolSize: 5, lineStyle: { width: 3 }, areaStyle: { color: 'rgba(64, 158, 255, .16)' } }]
    })
    this.updateChart()
    if (typeof ResizeObserver !== 'undefined') {
      this.observer = new ResizeObserver(() => this.chart.resize())
      this.observer.observe(this.$refs.chart)
    } else window.addEventListener('resize', this.resizeChart)
  },
  beforeDestroy() {
    if (this.observer) this.observer.disconnect()
    else window.removeEventListener('resize', this.resizeChart)
    if (this.chart) this.chart.dispose()
  },
  methods: {
    resizeChart() { if (this.chart) this.chart.resize() },
    updateChart() { if (this.chart) this.chart.setOption({ series: [{ data: this.data }] }) }
  }
}
</script>

<style scoped>.score-box { width: 100%; height: 100%; min-height: 0; }</style>
